(() => {
  const root = document.documentElement;
  const sync = () => {
    const light = root.dataset.mmMode === 'light';
    document.querySelectorAll('[data-mm-toggle]').forEach(button => {
      button.setAttribute('aria-pressed', String(light));
      button.setAttribute('aria-label', light ? button.dataset.darkLabel : button.dataset.lightLabel);
      button.title = button.getAttribute('aria-label');
    });
  };
  document.addEventListener('click', event => {
    if (event.target.closest('[data-mm-toggle]')) {
      const update = () => {
        root.dataset.mmMode = root.dataset.mmMode === 'light' ? 'dark' : 'light';
        try { localStorage.setItem('mymancave-mode', root.dataset.mmMode); } catch {}
        sync();
      };
      if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) document.startViewTransition(update);
      else update();
    }
    document.querySelectorAll('.mm-mobile[open]').forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.mm-mobile[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
  document.addEventListener('shopify:section:load', sync);
  sync();
})();
